import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AdminDashboard } from "./components/AdminDashboard";
import { HelpPage } from "./components/HelpPage";
import "./styles/index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Missing #root element in index.html");
}

const path = window.location.pathname;

createRoot(rootElement).render(
  <StrictMode>
    {path === "/admin/feedback" ? (
      <AdminDashboard />
    ) : path === "/help" ? (
      <HelpPage />
    ) : (
      <App />
    )}
  </StrictMode>,
);
